/* eslint-disable */

import request from '@/utils/request'

export function getCashList(data = {}) {
  return request({
    url: '/config-ticket-service/v1/audit/cash-statement',
    method: 'get',
    params: data
  })
}
export function updateCashList(data = {}) {
  return request({
    url: '/config-ticket-service/v1/audit/cash-statement',
    method: 'post',
    data
  })
}
export function getTicketOfficeList(data = {}) {
  return request({
    url: '/config-ticket-service/v1/ticket-office?byIp=false',
    method: 'get',
    params: data
  })
}
export function getCashierList(data = {}) {
  return request({
    // user_group
    // 12: FO-All, 42: ANNINH, 46: Sale-All
    url: '/config-service/v1/account?userGroupIds=12&userGroupIds=46&userGroupIds=42',
    method: 'get',
    params: data
  })
}

export function getPermissionToConfirm(params) {
  return request({
    url: '/config-ticket-service/v1/ticket/assign',
    method: 'get',
    params: params
  })
}
